import { Controller } from '@hotwired/stimulus'

// Tracks initial view for public share pages
// Note: Heartbeat tracking is handled by _heartbeat_script.html.erb to avoid duplicates
export default class extends Controller {
  static values = {
    token: String
  }

  connect() {
    this.viewTracked = false
    this.trackView()
  }

  async trackView() {
    if (this.viewTracked) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      await fetch(`/share/${this.tokenValue}/view`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken || ''
        }
      })
      this.viewTracked = true
    } catch (error) {
      console.debug('Error tracking view:', error)
    }
  }
}
